<template>
  <div>
    <div class="vx-row mt-0">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label pl-1">Outbound Reference</label>
        <vs-input
          class="w-full"
          v-model="outboundReference"
          placeholder="Enter outbound reference"
          @keyup.enter="searchPreview"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full" style="display:flex;align-items:flex-end;">
        <vs-button
          color="warning"
          class="btn mb-4 md:mb-0"
          @click="searchPreview"
          :disabled="outboundReference == ''"
        >
          Search
        </vs-button>
      </div>
    </div>

    <div class="vx-row mt-6" v-if="showPreview && previewData" style="display:flex;align-items:stretch;">
      <div class="vx-col md:w-1/2 w-full" style="display:flex;">
        <vs-card style="width:100%;display:flex;flex-direction:column;">
          <div slot="header">
            <span style="font-size:14px;font-weight:600;">Outbound Info</span>
          </div>
          <table style="width:100%">
            <tr>
              <td style="padding:4px 0;font-weight:bold;width:40%;">Outbound Reference</td>
              <td style="padding:4px 0;">{{ previewData.outbound_reference }}</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Status</td>
              <td style="padding:4px 0;">
                <vs-chip :color="statusColor">{{ statusLabel }}</vs-chip>
              </td>
            </tr>
            <tr v-if="previewData.client">
              <td style="padding:4px 0;font-weight:bold;">Client</td>
              <td style="padding:4px 0;">{{ previewData.client.client_code }}</td>
            </tr>
            <tr v-if="previewData.origin">
              <td style="padding:4px 0;font-weight:bold;">Origin</td>
              <td style="padding:4px 0;">{{ previewData.origin.name }}</td>
            </tr>
            <tr v-if="previewData.destination">
              <td style="padding:4px 0;font-weight:bold;">Destination</td>
              <td style="padding:4px 0;">{{ previewData.destination.name }}</td>
            </tr>
            <tr v-if="previewData.order_type">
              <td style="padding:4px 0;font-weight:bold;">Order Type</td>
              <td style="padding:4px 0;">{{ previewData.order_type.order_type }}</td>
            </tr>
          </table>
        </vs-card>
      </div>

      <div class="vx-col md:w-1/2 w-full" style="display:flex;">
        <vs-card style="width:100%;display:flex;flex-direction:column;">
          <div slot="header">
            <span style="font-size:14px;font-weight:600;">Product</span>
          </div>
          <ul style="list-style:none;padding:0;margin:0;" v-if="detailLines.length">
            <li v-for="(line, idx) in detailLines" :key="idx" style="padding:4px 0;">
              <span style="font-weight:bold;">[{{ line.committed }}/{{ line.total }}]</span> {{ line.code }}
            </li>
          </ul>
          <p v-else style="margin:0;">Tidak ada detail product.</p>
        </vs-card>
      </div>
    </div>

    <div class="vx-row mt-6" v-if="showPreview && previewData && !closeResult">
      <div class="vx-col w-full">
        <vs-alert :active="true" :color="isPartially ? 'warning' : 'danger'">
          <span v-if="isPartially">Outbound ini berstatus Partially Committed dan bisa di-close. Klik Close Outbound untuk menyesuaikan target per product dengan qty yang sudah dicommit.</span>
          <span v-else>Hanya outbound berstatus Partially Committed yang bisa di-close. Status saat ini: {{ statusLabel }}.</span>
        </vs-alert>
      </div>
      <div class="vx-col md:w-1/4 w-full mt-4" v-if="isPartially">
        <vs-button color="primary" class="btn" @click="showConfirmModal = true">
          Close Outbound
        </vs-button>
      </div>
    </div>

    <vs-popup title="Konfirmasi Close Outbound" :active.sync="showConfirmModal" v-if="previewData">
      <p style="margin-bottom:12px;">Setelah di-close, target tiap product akan disamakan dengan qty yang sudah dicommit:</p>
      <ul v-if="detailLines.length" style="margin-bottom:16px;">
        <li v-for="(line, idx) in detailLines" :key="idx" style="padding:4px 0;">
          <strong>{{ line.code }}</strong> <strong>{{ line.committed }}/{{ line.total }} &#8594; {{ line.committed }}/{{ line.committed }}</strong>
        </li>
      </ul>
      <p style="margin-bottom:16px;">Status menjadi <strong>Fully Committed</strong>. Lanjutkan?</p>
      <div style="display:flex;justify-content:flex-end;">
        <vs-button color="grey" class="btn mr-2" @click="showConfirmModal = false">Batal</vs-button>
        <vs-button color="primary" class="btn" @click="confirmClose">Ya, Close</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "CloseOutbound",
  data() {
    return {
      outboundReference: "",
      previewData: null,
      showPreview: false,
      showConfirmModal: false,
      closeResult: null,
    };
  },
  computed: {
    isPartially() {
      return this.previewData && this.previewData.status_id === 2;
    },
    statusLabel() {
      if (!this.previewData) return "-";
      if (this.previewData.status_id === 3) return "Fully Committed";
      if (this.previewData.status_id === 2) return "Partially Committed";
      if (this.previewData.status && this.previewData.status.name) return this.previewData.status.name;
      return "Uncommitted";
    },
    statusColor() {
      if (!this.previewData) return "grey";
      if (this.previewData.status_id === 3) return "success";
      if (this.previewData.status_id === 2) return "warning";
      return "grey";
    },
    detailLines() {
      if (!this.previewData || !Array.isArray(this.previewData.details)) return [];
      return this.previewData.details.map((item) => ({
        committed: item.committed_qty,
        total: item.base_qty,
        code: item.product ? item.product.product_code : "-",
      }));
    },
  },
  methods: {
    searchPreview() {
      if (this.outboundReference == "") {
        this.$vs.notify({ color: "danger", title: "Error", text: "Outbound Reference is required" });
        return false;
      }
      this.$emit("loading", true);
      this.showPreview = false;
      this.closeResult = null;
      this.$http.post("support/outbound/preview", { outbound_reference: this.outboundReference })
        .then((res) => {
          this.$emit("loading", false);
          this.previewData = res.data.data;
          this.showPreview = true;
        })
        .catch((error) => {
          this.$emit("loading", false);
          this.$emit("error", error);
        });
    },
    refreshPreview() {
      return this.$http.post("support/outbound/preview", { outbound_reference: this.outboundReference })
        .then((res) => {
          this.previewData = res.data.data;
          this.showPreview = true;
        });
    },
    confirmClose() {
      if (!this.isPartially) {
        this.$vs.notify({ color: "danger", title: "Error", text: "Hanya outbound Partially Committed yang bisa di-close" });
        return false;
      }
      this.showConfirmModal = false;
      this.$emit("loading", true);
      this.$http.post("support/outbound/close", { outbound_reference: this.outboundReference })
        .then((res) => {
          this.$emit("loading", false);
          const body = res.data || {};
          const summary = body.data || body.summary || body.result || {};
          const detailsUpdated = summary.details_updated !== undefined ? summary.details_updated
            : summary.outbound_details_updated !== undefined ? summary.outbound_details_updated
            : summary.updated !== undefined ? summary.updated
            : summary.count !== undefined ? summary.count : null;
          const ref = summary.outbound_reference || this.outboundReference;
          this.closeResult = {
            message: body.message || summary.message || "Outbound closed successfully.",
            details_updated: detailsUpdated,
            outbound_reference: ref,
            raw: JSON.stringify(body).slice(0, 1000),
          };
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: `Outbound '${ref}' berhasil di-close.${typeof detailsUpdated === "number" ? ` ${detailsUpdated} detail product diupdate.` : ""}`,
          });
          return this.refreshPreview();
        })
        .then(() => {
          this.$emit("loading", false);
        })
        .catch((error) => {
          this.$emit("loading", false);
          this.$emit("error", error);
        });
    },
  },
};
</script>
